import { useQuery } from '@tanstack/react-query';
import type { QueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';

export const activityLogKeys = {
  all: ['activityLog'] as const,
  byProject: (projectId: number) => [...activityLogKeys.all, 'project', projectId] as const,
};

/** Invalidates the activity log for a project after a 500ms delay
 *  to allow the backend fire-and-forget task to complete first. */
export const invalidateActivityLogDelayed = (queryClient: QueryClient, projectId: number) => {
  setTimeout(() => {
    queryClient.invalidateQueries({ queryKey: activityLogKeys.byProject(projectId) });
  }, 500);
};

/**
 * Fetch the activity log for a project (newest entries first).
 */
export const useActivityLogQuery = (projectId: number, limit = 50) => {
  return useQuery({
    queryKey: activityLogKeys.byProject(projectId),
    queryFn: () => apiClient.getActivityLog(projectId, limit),
    enabled: projectId > 0,
    gcTime: 2 * 60 * 1000,
    staleTime: 1000,
  });
};
